module.exports = "/fonts/FiraSans-MediumItalic.ttf";